import { defineFeature } from '@/lib/platform/system';
import { schedulesMachine } from '@/features/schedules/state/schedules.machine';

export const features = [
  defineFeature({
    id: 'schedules',
    machine: schedulesMachine,
    emits: [],
    handles: [],
    accepts: [
      'schedule.choose-route',
      'schedule.choose-direction',
      'schedule.choose-stop',
      'schedule.remember-choice',
      'schedule.refresh-arrivals',
    ],
  }),
] as const;
